import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import { Observable } from 'rxjs';
import { URLS } from '../../constant/interface';
import { DialogService } from '../../services/dialog.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-short-chain-config',
  templateUrl: './icc-short-chain-config.component.html',
  styles: [],
})
export class IccShortChainConfigComponent implements OnInit {
  constructor(private modal: NzModalRef, public http: _HttpClient, private dialogService: DialogService) {}
  // 融合消息模板
  template: any;
  // 是否显示按钮 "生成短链"
  isGeneratorLink: boolean;

  // 选择短链还是选择链接（长链）
  isShortLink = true;

  types: any;
  websiteList: any;
  websiteFilterList: any;
  shortLinks: any;

  website: any;
  longAdress: any;
  domain: any;

  msgType: number;

  targetUrlId: any;
  uuid: string;

  ngOnInit() {
    this.initData();
  }
  /* 初始化数据 */
  initData() {
    const me = this;
    this.websiteList = [];
    this.shortLinks = [];
    this.requestWebsiteList().subscribe({
      next(list: any[]) {
        me.websiteList = me.websiteList.concat(list);
        if (me.template && me.template.requireShortUrl && me.template.longUrlName) {
          const tempList = list.filter(item => item.name === me.template.longUrlName);
          me.website = tempList.length ? tempList[0].id : '';
          me.longAdress = tempList.length ? tempList[0].tUrl : '';
        }
      },
      error(errorMsg) {
        me.dialogService.notification.error(`请求失败`, errorMsg);
      },
    });
    this.requestWxAppList().subscribe({
      next(list: any[]) {
        me.websiteList = me.websiteList.concat(list);
        if (me.template && me.template.requireShortUrl && me.template.longUrlName) {
          const tempList = list.filter(item => item.name === me.template.longUrlName);
          me.website = tempList.length ? tempList[0].id : '';
          me.longAdress = tempList.length ? tempList[0].openLink : '';
        }
      },
      error(errorMsg) {
        me.dialogService.notification.error(`请求失败`, errorMsg);
      },
    });
    this.requestShortLinks().subscribe({
      next(list: any[]) {
        me.shortLinks = list;
        if (me.template && me.template.requireShortUrl && me.template.serverUrl) {
          me.domain = me.template.serverUrl;
        }
      },
      error(errorMsg) {
        me.dialogService.notification.error(`请求失败`, errorMsg);
      },
    });
  }
  /* 请求网址 */
  requestWebsiteList() {
    return new Observable(observer => {
      this.http
        .post(URLS.templateShortLinkWebsits.url, {
          pi: 1,
          ps: 10000,
          params: {
            auditStatus: 1,
          },
        })
        .subscribe(
          res => {
            if (res.status !== 0) {
              observer.error(res.errorMsg);
              return;
            }
            if (res.list) {
              observer.next(res.list);
            } else {
              observer.error('目前暂无长链接，请先添加长链接.');
            }
          },
          error => {
            observer.error(error.errorMsg);
          },
        );
    });
  }
  /* 请求微信小程序网址 */
  requestWxAppList() {
    return new Observable(observer => {
      this.http
        .post(URLS.appletPage.url, {
          pi: 1,
          ps: 10000,
          params: {
            auditStatus: 1,
            wxApp:{
              nickname: ""
            }
          },
        })
        .subscribe(
          res => {
            if (res.status !== 0) {
              observer.error(res.errorMsg);
              return;
            }
            if (res.list) {
              observer.next(res.list);
            } else {
              observer.error('目前暂无小程序链接，请先添加.');
            }
          },
          error => {
            observer.error(error.errorMsg);
          },
        );
    });
  }
  /* 请求短域名 */
  requestShortLinks() {
    return new Observable(observer => {
      this.http.get(URLS.templateShortLinkDomains.url).subscribe(
        res => {
          if (res.status === 0 && res.data) {
            observer.next(res.data);
          } else {
            observer.error(res.errorMsg);
          }
        },
        error => {
          observer.error(error.errorMsg);
        },
      );
    });
  }
  /* 生成短链 */
  generatorShortLink() {
    return new Observable(observer => {
      const selectedList = this.websiteList.filter(item => item.id === this.website);
      let params = {
        longUrlName: selectedList[0].name,
        longUrl: this.longAdress,
        serverUrl: this.domain,
        msgType: this.msgType,
        uuid: this.uuid,
        targetUrlId: this.targetUrlId,
        requireShortUrl: false,
      };
      this.http.post(URLS.templateShortLinkGenerate.url, params).subscribe(
        res => {
          if (res.status === 0 && res.data) {
            observer.next(res.data);
          } else {
            observer.error(res.errorMsg);
          }
        },
        error => {
          observer.error(error.errorMsg);
        },
      );
    });
  }
  /* 下拉选择 */
  changeSite(id) {
    const selectedList = this.websiteFilterList.filter(item => item.id === id);
    this.longAdress = selectedList[0].types == 1 ? selectedList[0].openLink : selectedList[0].tUrl;
    this.targetUrlId = id;
  }
  changeTypes(types) {
    this.website = null;
    this.longAdress = null;
    this.targetUrlId = null;
    this.websiteFilterList = this.websiteList.filter(item => item.types === Number(types));
  }
  /* 弹窗-取消 */
  cancel() {
    this.modal.triggerCancel();
  }
  /* 弹窗-确认 */
  confirm() {
    const selectedList = this.websiteList.filter(item => item.id === this.website);
    if (this.isShortLink) {
      this.modal.close({
        longUrlName: selectedList[0].name,
        longUrl: this.longAdress,
        serverUrl: this.domain,
        targetUrlId: this.targetUrlId,
        requireShortUrl: true,
      });
    } else {
      this.modal.close({
        longUrlName: selectedList[0].name,
        longUrl: this.longAdress,
        targetUrlId: this.targetUrlId,
      });
    }
  }
  /* 生成短链 */
  generatorLinkClick() {
    const me = this;
    this.generatorShortLink().subscribe({
      next(data: any) {
        me.modal.close(data);
      },
      error(errorMsg) {
        me.dialogService.notification.error(`请求失败`, errorMsg);
      },
    });
  }
}
